import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const SelectInput = ({ value, changeHandler, marginZero, outlined, options, label, ...props }) => {
    const classes = useStyles();

    return (
        <>
            {label && (
                <p style={{ marginBottom: marginZero ? '0rem' : '0.5rem' }} className="inpt_label">
                    {label}
                </p>
            )}
            <div className={`custom_select ${outlined ? 'outlined' : ''}`}>
                <FormControl {...props} className={classes.formControl}>
                    <InputLabel id="simple-select-label">{label}</InputLabel>
                    <Select labelId="simple-select-label" id="simple-select" value={value} onChange={changeHandler}>
                        {options.map((ele, i) => {
                            return (
                                <MenuItem key={i} value={ele.value}>
                                    {ele.name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </div>
        </>
    );
};

export default SelectInput;
